import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../pages/shared/BrandModal.css";

const Confirm = (props) => {
  const toggle = () => props.setToggle(!props.toggle);

  const onConfirm = async () => {
    props.onConfirm();
    toggle();
  };

  return (
    <Modal isOpen={props.toggle} toggle={toggle} className="brand-modal">
      <ModalHeader toggle={toggle}>Confirm</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">{props.text}</p>
        <div className="brand-modal__actions">
          <button type="button" className="brand-modal__btn brand-modal__btn--primary" onClick={onConfirm}>
            <FontAwesomeIcon icon={faCheck} /> Confirm
          </button>
          <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={toggle}>
            <FontAwesomeIcon icon={faTimes} /> Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Confirm;
